"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./styles/app.scss");
const vue_1 = require("vue");
const Sentry = __importStar(require("@sentry/vue"));
// import { BrowserTracing } from "@sentry/tracing";
const i18n_1 = __importDefault(require("./common/i18n"));
const routes_1 = __importDefault(require("./routes"));
const App_vue_1 = __importDefault(require("./pages/App.vue"));
const FetchComponent_1 = __importDefault(require("./common/utils/FetchComponent"));
const pinia_1 = require("pinia");
const app = (0, vue_1.createApp)(App_vue_1.default)
    .use(i18n_1.default)
    .use(routes_1.default)
    .use(FetchComponent_1.default)
    .use((0, pinia_1.createPinia)());
Sentry.init({
    app,
    dsn: "https://5679af41699947e6972d53266afba3f7@o310262.ingest.sentry.io/6005457",
    ignoreErrors: [
        'UnauthorizedServerError'
    ]
    // integrations: [
    //     new BrowserTracing({
    //         routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    //         tracingOrigins: [
    //             "shop3test.marso.hu/api",
    //             "root.marsodealer.hu/user-cars/alcar-api",
    //             "root.marsodealer.hu/axapta-product-popup"
    //         ],
    //     }),
    // ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    // tracesSampleRate: 0.1,
});
app.mount('#app');
exports.default = app;
